import { render, staticRenderFns } from "./ProzessResourceHistory.vue?vue&type=template&id=89c64daa"
import script from "./ProzessResourceHistory.vue?vue&type=script&lang=js"
export * from "./ProzessResourceHistory.vue?vue&type=script&lang=js"
import style0 from "./ProzessResourceHistory.vue?vue&type=style&index=0&id=89c64daa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports